import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import { trackBtnClick } from "@/lib/helper";
import Div100vh from "react-div-100vh";
import checkBg from "@/assets/images/check-bg.png";
import tenantTile from "@/assets/images/tenant-tile.svg";
import landlordTile from "@/assets/images/landlord-tile.svg";
import PrimaryButton from "../buttons/PrimaryButton";

const NewSplash = ({ config }) => {
  const navigate = useNavigate();
  const [showVideo, setShowVideo] = useState(null); // State to control video playback

  // Function to handle video playback
  const playVideo = (url) => {
    setShowVideo(url); // Set the video URL to be played
  };

  // Function to close the video
  const closeVideo = () => {
    setShowVideo(false);
  };

  const handleNavigate = () => {
    trackBtnClick("Next", "New Splash Screen");
    navigate("/work");
  };

  return (
    <div className="overflow-scroll bg-gradient-to-b from-[#010101] via-[#000010] to-[#0000cc] ">
      <div className="flex flex-col justify-between h-screen">
        <img
          className="absolute bottom-4 -z-0"
          src={checkBg}
          alt="Background"
        />
        <div className="flex flex-col justify-between w-full h-full max-w-md mx-auto text-white pt-8 px-4">
          {/* Tenant and Landlord Benefits */}
          <div className="space-y-6 mb-3 mt-6 w-full">
            {/* Tenant Benefits */}
            {/* <div className="relative bg-black rounded-xl overflow-hidden">
              <img
                src={config.tenant.thumbnailUrl} // Tenant Thumbnail
                alt="Tenant Thumbnail"
                className="w-full h-44 object-cover"
              />
              <div className="absolute inset-0 bg-black bg-opacity-40"></div>
              <div className="absolute inset-0 flex flex-col justify-center px-6">
                <p className="text-sm font-semibold uppercase">Benefits for</p>
                <h2 className="text-2xl font-bold mt-1">Tenant</h2>
                <button
                  onClick={() => playVideo(config.tenant.youtubeUrl)} // Play video on click
                  className="absolute top-4 right-4 w-10 h-10 bg-white text-black rounded-full flex items-center justify-center"
                >
                  ▶
                </button>
              </div>
            </div> */}

            <img
              className=""
              src={tenantTile}
              alt="Tenant Benefits"
              onClick={() => playVideo(config.tenant.youtubeUrl)}
            />
            <img
              className=""
              src={landlordTile}
              alt="Landlord Benefits"
              onClick={() => playVideo(config.landlord.youtubeUrl)}
            />

            {/* Landlord Benefits */}
            {/* <div className="relative bg-black rounded-xl overflow-hidden">
              <img
                src={config.landlord.thumbnailUrl} // Landlord Thumbnail
                alt="Landlord Thumbnail"
                className="w-full h-44 object-cover"
              />
              <div className="absolute inset-0 bg-black bg-opacity-40"></div>
              <div className="absolute inset-0 flex flex-col justify-center px-6">
                <p className="text-sm font-semibold uppercase">Benefits for</p>
                <h2 className="text-2xl font-bold mt-1">Landlord</h2>
                <button
                  onClick={() => playVideo(config.landlord.youtubeUrl)} // Play video on click
                  className="absolute top-4 right-4 w-10 h-10 bg-white text-black rounded-full flex items-center justify-center"
                >
                  ▶
                </button>
              </div>
            </div> */}
          </div>

          {/* Title Section */}
          <div className="flex flex-col items-left justify-center">
            <h1 className="mt-4 min-w-max uppercase px-6 text-left text-[#eee] text-xl sm:text-2xl tracking-normal font-medium">
              {config.title}
            </h1>

            {/* Description */}
            <div className="mt-6 text-left space-y-6 px-4">
              {config.points.map((item, index) => (
                <div key={index} className="flex items-start gap-4">
                  <span
                    className={`text-lg sm:text-2xl text-[#888] ${
                      index === 0 ? "mx-1" : "mx-0"
                    }`}
                  >
                    {index + 1}
                  </span>
                  <span className="text-white text-sm font-light">{item}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Next Button */}
          {/* <button
            className="z-30 my-8 w-full py-3 bg-white text-black font-semibold rounded-full"
            onClick={handleNavigate}
          >
            Next
          </button> */}
          <div className="pb-8 px-4 z-30">
          <PrimaryButton
          handleClick={()=>handleNavigate()}
          text={"Next"}
          />
          </div>
        </div>

        {/* Video Player Modal */}
        {showVideo && (
          <div
            className="fixed inset-0 bg-black bg-opacity-90 flex items-center justify-center z-50"
            onClick={() => {
              return;
            }}
          >
            <iframe
              width="100%"
              height="100%"
              src={showVideo.replace("watch?v=", "embed/")} // Embed YouTube URL
              allow="autoplay; fullscreen"
              allowFullScreen
              title="YouTube Video"
            ></iframe>
            <button
              onClick={closeVideo}
              className="absolute text-right top-4 right-4 text-white bg-gradient-to-r from-[#010101]/0 via-[#000]/0 to-[#000] px-4 py-2 rounded-lg z-20 w-full"
            >
              Close
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default NewSplash;
